import EventEmitter from "events"

if (!window.kenhubEventEmitter) {
  window.kenhubEventEmitter = new EventEmitter()
}

const history = []

const signals = {
  emit: (name, props) => {
    history.push({name, props})
    window.kenhubEventEmitter.emit(name, props)
  },

  on: (eventName, handler) =>
    window.kenhubEventEmitter.on(eventName, handler),

  history: history,

  removeAll: () => window.kenhubEventEmitter.removeAllListeners()
}

export default signals
